import { VERIFY_RUNNING, VERIFY_SUCCESS } from '../../../constants/verificationStatus';
import { getExperimentListPromise } from '../rockyExperimentCtrl';

class SweepContentData {

  constructor() {
    this.data = new Map(); //key-verificationId, value [sweep]
  }

  saveData = (sweepId, data) => {
    this.data.set(sweepId, data);
  }

  getLocalData = (sweepId) => {
    return this.data.get(sweepId) || {};
  }

  getDataPromise = (sweepId, isNew) => {
    return new Promise((resolve, reject) => {
      const data = this.data.get(sweepId);
      if (!data || isNew) {
        getExperimentListPromise({ experimentGroupId: sweepId }).then(res => {
          this.saveData(sweepId, res)
          resolve(res);
        })
      } else {
        resolve(data)
      }
    })
  }

  getExpList = (sweepId) => {
    const data = this.data.get(sweepId)
    console.log(data)
    return data && data.experiments ? data.experiments : []
  }

  getSuccessExpList = (sweepId) => {
    const list = this.getExpList(sweepId);
    return list.filter(item => item.status === VERIFY_SUCCESS || item.status === VERIFY_RUNNING)
  }

  getExpInfo = (sweepId, expId) => {
    const list = this.getExpList(sweepId)
    const findInfo = list.find(item => item.id === expId);
    return findInfo || {};
  }


  getBaseData = (sweepId) => {
    const list = this.getExpList(sweepId)
    const findInfo = list.find(item => item.name === 'Base');
    return findInfo ? findInfo : null;
  }

  getBaseDataPromise = async (sweepId) => {
    const info = await this.getDataPromise(sweepId)
    const list = info && info.list ? info.list : []
    const findInfo = list.find(item => item.name === 'Base');
    return findInfo ? findInfo : null;
  }

  getExpDataPromise = async (sweepId) => {
    const info = await this.getDataPromise(sweepId)
    const list = info && info.experiments ? info.experiments : []
    return list || [];
  }

  addExpList = (sweepId, newExpContent) => {
    const data = this.data.get(sweepId)
    let expList = data && data.experiments ? [...data.experiments] : []
    expList.push(newExpContent);
    this.data.set(sweepId, { ...data, experiments: expList })
  }

  deleteExpList = (sweepId, deleteArr) => {
    const data = this.data.get(sweepId)
    let expList = data && data.experiments ? [...data.experiments] : []
    expList = expList.filter(item => !deleteArr.includes(item.id));
    this.data.set(sweepId, { ...data, experiments: expList })
  }

  updateExpContent = (sweepId, expId, updateContent) => {
    const data = this.data.get(sweepId)
    let expList = data && data.experiments ? [...data.experiments] : []
    expList = expList.map(item => {
      if (item.id === expId) {
        return { ...item, ...updateContent }
      }
      return item
    })
    this.data.set(sweepId, { ...data, experiments: expList })
  }

  cleanSweepInfo = (sweepId) => {
    this.data.delete(sweepId)
  }

  clean = () => {
    this.data = new Map();
    this.resultData = new Map();
  }
}


const sweepContentData = new SweepContentData();

export default sweepContentData